import { ProductConstant } from '../actions/constants/ProductConstant';

// IMP-326(FE-C3): 모바일 무한스크롤(ProductList/ProductListNewInstalled) 이 append 로 목록을
// 무한 누적하여 대량 스크롤 시 브라우저 메모리 폭증 → 탭 크래시 위험. 누적 상한을 두어 가장
// 오래된 항목부터 버린다(최신 스크롤 방향 데이터 보존). page=1/필터변경 등 replace 경로는 무영향.
// 30건/페이지 기준 ~50페이지로, 실사용 모바일 스크롤 깊이를 크게 상회하는 여유값.
// [트레이드오프] 소비 컴포넌트가 가상 스크롤(react-window) 미적용이라, 상한 도달 후 append 시
// 상단 DOM 이 제거되어 위로 스크롤하면 콘텐츠가 사라지고 스크롤 점프가 발생할 수 있다. 근본
// 해법은 가상 스크롤(이슈 #176 완료기준)이며, 본 변경은 크래시 방지를 우선한 부분 조치다.
const MAX_ACCUMULATED_PRODUCTS = 1500;

const initialState = {
	products: [],
	orisninfo: {},
	statistics: [],
	savedFilters: [],
	producterrasshow: false,
	filterOptions: null,
	filterDateOptions: null,
	filters: null,
	dsfilters: [],
	sort: null,
	producterrs: [],
	producterrsmatch: [],
	producterr: { errs: {} },
	producterrasshow: false,
	filterErrOptions: null,
	filterErrDateOptions: null,
	errfilters: {}, // IMP-077: errfilters 는 항상 객체 (GET_ERRORS 정규화와 일관). priority 차원은 컴포넌트 로컬 소유.
	errsort: null,
	page: 1,
	errpage: 1,
	viewtype: "All",
	totalproductcount: 0,
	totalproducterrcount: 0,
	product: {},
	isUpdateRes: false,
	isLoading: false,
	isErrLoading: false,
	acq: {
		sn: "",
		acquisitions: []
	},
	totalAcqCount: 0,
	acqchart: {
		sn: "",
		acquisitions: []
	},
	siteProducts: [],
	rlogs: []
};

export const ProductReducer = (state = initialState, action) => {
	switch (action.type) {
		case ProductConstant.UPDATE_DSFILTER:
			return { ...state, dsfilters: action.dsfilters };
		case ProductConstant.SET_VIEWTYPE_STOCK:
			return { ...state, viewtype: "Stock" };
		case ProductConstant.SET_VIEWTYPE_ALL:
			return { ...state, viewtype: "All" };
		case ProductConstant.GET_FAV_PRODUCTLIST:
		case ProductConstant.GET_PRODUCTLIST:
			return {
				...state,
				products: (action.append && action.result.page != 1) ? [...state.products, ...action.result.list].slice(-MAX_ACCUMULATED_PRODUCTS) : action.result.list,
				totalproductcount: action.result.totalcount,
				filterOptions: action.result.filterOptions,
				filterDateOptions: action.result.filterDateOptions,
				filters: action.result.filters,
				page: action.result.page,
				sort: action.result.sort,
				viewtype: action.vtype,
				isUpdateRes: false
			};
		case ProductConstant.GET_ERRORS: {
			// IMP-077: errs.priority 차원은 컴포넌트 로컬 상태(priorityFilter)가 소유.
			// 서버 echo 필터에서 분리 저장하여 필터 전환 시 잔존 방지 (BUG-063 근본 수정).
			// 정규화 목적의 의도적 제거 (CLAUDE.md §7 silent-drop 예외 — 정규화).
			const { 'errs.priority': _omitPriority, ...serverErrFilters } = action.result.filters || {};
			return {
				...state,
				producterrs: (action.append && action.result.page != 1) ? [...state.producterrs, ...action.result.list] : action.result.list,
				totalproducterrcount: action.result.totalcount,
				filterErrOptions: action.result.filterOptions,
				filterErrDateOptions: action.result.filterErrDateOptions,
				producterrsmatch: action.result.match || {},
				errfilters: serverErrFilters,
				errsort: action.result.sort,
				errpage: action.result.page,
				isUpdateRes: false
			};
		}
		case ProductConstant.GET_ERROR:
			return {
				...state,
				producterr: action.result.data,
				isUpdateRes: false
			};
		case ProductConstant.GET_STATISTICS:
			return { ...state, statistics: action.result }
		case ProductConstant.GET_SAVED_FILTERS:
			return { ...state, savedFilters: action.result };
		case ProductConstant.BULKUPDATE_PRODUCTINFO:
			return {
				...state,
				products: state.products.map((u) => {
					const item = action.products.filter(p => p.sn == u.sn);
					return item.length > 0 ? item[0] : u;
				}),
				isUpdateRes: true,
			};
		case ProductConstant.UPDATE_PRODUCTERRORINFO:
			if (action.result.list.length > 0) {
				const item = action.result.list[0];
				const newproducts = action.isClose ?
					state.producterrs.filter((u) => (u.errs._id != item.errs._id)) :
					state.producterrs.map((u) => (u.errs._id == item.errs._id ? item : u))
				return {
					...state,
					producterrs: newproducts,
					producterr: { errs: {} },
					producterrasshow: false
				};
			} else {
				return {
					...state,
					producterr: { errs: {} },
					producterrasshow: false
				};
			}
		case ProductConstant.SET_ERROREDIT:
			return {
				...state,
				producterr: action.err,
				producterrasshow: action.errshow,
			};
		case ProductConstant.SET_ERROREDIT_HIDE:
			return {
				...state,
				producterr: { errs: {} },
				producterrasshow: false,
			};
		case ProductConstant.UPDATE_PRODUCTINFO:
			return {
				...state,
				products: state.products.map((u) => (u._id == action.product._id ? action.product : u)),
				product: action.product,
				isUpdateRes: true,
			};
		case ProductConstant.GET_PRODUCT_OLD:
			return {
				...state,
				product: {...action.product, old : true},
				orisninfo : action.orisninfo
			};
		case ProductConstant.GET_PRODUCT:
			return {
				...state,
				product: action.product
			}
		case ProductConstant.GET_PRODUCTS_BY_SITE_ID:
			return {
				...state,
				siteProducts: action.item
			}
		case ProductConstant.GET_PRODUCT_ACQ:
			return {
				...state,
				acq: {
					sn: action.sn,
					acquisitions: action.acquisitions.map(x => {
						return {
							activationTime: Number(x.activationtime) || 0,
							confirm: x.confirm,
							description: x.description,
							modality: x.modality,
							protocol: x.protocol,
							startTime: Number(x.startTime) || 0,
							timestamp: Number(x.timestamp) || 0,
						}
					}),
				},
				page: action.page,
				sort: action.sort,
				totalAcqCount: action.totalCount
			}
		case ProductConstant.GET_PRODUCT_ACQ_CHART:
			return {
				...state,
				acqchart: {
					sn: action.sn,
					acquisitions: action.acquisitions.map(x => {
						return {
							activationTime: Number(x.activationtime) || 0,
							confirm: x.confirm,
							description: x.description,
							modality: x.modality,
							protocol: x.protocol,
							startTime: Number(x.startTime) || 0,
							timestamp: Number(x.timestamp) || 0,
						}
					}),
				},
			}
		case ProductConstant.CLEAR_PRODUCT_ACQ_INFO:
			return {
				...state,
				acq: {},
				acqchart: {},
				page: 1,
				totalAcqCount: 0
			};
		case ProductConstant.GET_PRODUCT_DIA:
			return {
				...state,
				product: {
					...state.product,
					autoDiagnoses: action.append ?
						[...(state.product.autoDiagnoses || []), ...action.autodiagnoses] :
						action.autodiagnoses
				}
			};
    case ProductConstant.GET_PRODUCT_HISTORY:
      return {
        ...state,
        product: {
          ...state.product,
          histories: action.append ?
            [...(state.product.histories || []), ...action.histories] :
            action.histories
        }
      };
		case ProductConstant.GET_PRODUCT_RLOG:
			return {
				...state,
				rlogs: action.rlogs
			};
		case ProductConstant.SAVE_PRODUCT_RLOG:
			return {
				...state,
				rlogs: [...state.rlogs, action.rlog]
			};
		case ProductConstant.SET_PRODUCT_WARRANTY:
			return {
				...state,
				product: action.product
			};
		case ProductConstant.REGIST_PRODUCTINFO:
			return {
				...state,
				products: [...state.products, action.product],
				product: action.product,
				isUpdateRes: true
			};
		case ProductConstant.DELETE_PRODUCT:
			return { ...state, products: state.products.filter((u) => u._id !== action.delproductid), isUpdateRes: true };
		case ProductConstant.CLEAR_UPDATERES:
			return { ...state, isUpdateRes: false };
		case ProductConstant.LOADING:
			return { ...state, isLoading: true }
		case ProductConstant.LOADED:
			return { ...state, isLoading: false }
		case ProductConstant.ERR_LOADING:
			return { ...state, isErrLoading: true }
		case ProductConstant.ERR_LOADED:
			return { ...state, isErrLoading: false }
		default:
			return state;
	}
};
